export default __webpack_public_path__ + "static/breathwork-f94da4443f7d51b3d6e44c06ac6ed172.png";